import { MessageType } from '../../domain';
import { ExtendedMessageType } from '../types';

const byMessageTypeId =
  (messageTypeIds: Set<MessageType['id']>) =>
  ({ id }: ExtendedMessageType) =>
    messageTypeIds.has(id);

export const filterByMessageTypeIds = (
  messageTypes: ExtendedMessageType[],
  messageTypeIds: Set<MessageType['id']>,
) => messageTypes.filter(byMessageTypeId(messageTypeIds));
